import { render, staticRenderFns } from "./total-student-status.vue?vue&type=template&id=1caaceb0&scoped=true"
import script from "./total-student-status.vue?vue&type=script&lang=js"
export * from "./total-student-status.vue?vue&type=script&lang=js"
import style0 from "./total-student-status.vue?vue&type=style&index=0&id=1caaceb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caaceb0",
  null
  
)

export default component.exports